import { AuthenticationSettingsInterface } from "../../interfaces/account/AuthenticationSettingsInterface";

export const mapAuthenticationSettingsResponse = (response: {
    data: AuthenticationSettingsInterface;
}): AuthenticationSettingsInterface => response.data;
